import React, { useRef,useEffect,useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import "./Calendar.css";
import interactionPlugin from '@fullcalendar/interaction';


const Calendar = ({approvalView, fixedDates, items, onEventDrop,onEventReschedule,setSelectedItems, setUnsavedChanges }) => { 

  //trigger re-rendering the component whenever items change
  useEffect(() => {
    
  }, [items]);

  const deleteIconRef = useRef(null);    

    const handleEventReceive=(info)=>{ 
        const droppedEventId = info.draggedEl.getAttribute('data-id');       

         onEventDrop(droppedEventId, info.event.startStr);        
    }

    const handleEventReschedule = (changeInfo) => {
        const { event } = changeInfo;        
        const eventID = event._def.publicId;
        const newDate = event.startStr; // The new start date after the event was edited  
        
        onEventReschedule(eventID, newDate);
      };

      const handleEventDragStart = () => {
        // Add active class when event starts dragging
        deleteIconRef.current.classList.add('active');
      };
    
      const handleEventDragStop = (info) => {
        const trashIconRect = deleteIconRef.current.getBoundingClientRect();
        const eventRectX = info.jsEvent.clientX;
        const eventRectY = info.jsEvent.clientY;
    
        // Check if event was dropped on the delete icon
        if (
          eventRectX >= trashIconRect.left &&
          eventRectX <= trashIconRect.right &&
          eventRectY >= trashIconRect.top &&
          eventRectY <= trashIconRect.bottom
        ) {
          // Remove event             
          info.event.revert = false; // Prevent event from reverting
          // info.event.remove();    
          setSelectedItems((prevState) => prevState.filter((event) => event.id !== info.event.id));  
          setUnsavedChanges(true);          
        }
        deleteIconRef.current.classList.remove('active');
      };      


  return (<>
 <style>
{`
  .calendar .fc-prev-button.fc-button.fc-button-primary {
    background-image: url(${process.env.PUBLIC_URL}/Images/Campaigns/prev.png);
  }

  .calendar .fc-next-button.fc-button.fc-button-primary {
    background-image: url(${process.env.PUBLIC_URL}/Images/Campaigns/next.png);
  }
`}
</style>

    
    <div className="calendar">
    {/* <h1 className='center' style={{textTransform:"capitalize"}}>{title}</h1> */}
    <div className='dates-container'>
    <span id='start-date'>Start Date:- {fixedDates.start}</span>
    <span id='end-date'>End Date:-{fixedDates.end}</span>  
    </div>

      <FullCalendar
        height={"75vh"}           
        plugins={[dayGridPlugin,interactionPlugin]}
        initialView="dayGridMonth"
        fixedWeekCount={false}
        // weekends={false}
        eventAllow={(dropInfo) => {
          const eventDate = new Date(dropInfo.start);

          //campaign start date
          const StartDateString = fixedDates.start;
          const [startDay, startMonth, startYear] = StartDateString.split('/');
          const StartDate = new Date(`${startYear}-${startMonth}-${startDay}`);
          StartDate.setMinutes(StartDate.getMinutes() - 330); // Subtract 330 minutes (5 hours and 30 minutes)
          //campaign end date
          const EndDateString = fixedDates.end;
          const [endDay, endMonth, endYear] = EndDateString.split('/');
          const EndDate = new Date(`${endYear}-${endMonth}-${endDay}`); 
          EndDate.setMinutes(EndDate.getMinutes() - 330); // Subtract 330 minutes (5 hours and 30 minutes)         
        
          // For Approver- allow to add events 15 days prior to campaign start and 15 days post campaign end
          if(approvalView){
            if(StartDate-eventDate>15*(1000*60*60*24) || eventDate-EndDate> 15*(1000*60*60*24)) return false;
          }
          //for requestor - disallow adding events outside of start and end date range     
          else{
            if(eventDate<StartDate || eventDate>EndDate) return false;
          }    
        
          // Disallow weekend events (0 for Sunday, 6 for Saturday)
          const day = eventDate.getDay();
          if (day === 0 || day === 6) {
            return false;
          }
        
          // Allow event otherwise
          return true;
        }}
        events={items}
        headerToolbar={{
          left:"prev",
          center:"title",
          right:"next"
        }}     
        buttonIcons={false} 
        editable={true}
        droppable={true}
        eventReceive={handleEventReceive}
        eventChange={handleEventReschedule}  
        eventDragStart={handleEventDragStart}
        eventDragStop={handleEventDragStop}
        displayEventTime= {false} 
        eventDidMount={(info) => {
          // Set the title attribute for the event element
          info.el.setAttribute("title", info.event.title);
        }}          
      />      
      <div className='delete-area' ref={deleteIconRef}>
      <img src={process.env.PUBLIC_URL+"Images/Campaigns/DeleteIcon.png"} alt="delete-icon" /> 
      &nbsp;Drag and Drop here to delete items.
     </div>    
    </div>   
     
    </>
  );
};

export default Calendar;